import FullTable from 'js/components/full-table/index.js'
import { openModalConfirmRemove } from 'js/services/modals.js'
import template from './_table.pug'
import API from 'js/services/api'

export default Vue.extend({
  template: template(),
  components: {
    FullTable
  },
  props: {
    promts: Array,
    meta: Object
  },
  data() {
    return {
      showFilters: true,
      filters: {
        name: '',
        description: ''
      },
      lastQueryOptions: null
    }
  },
  computed: {
    defaultOrder() {
      return { currentField: 'name', currentDir: 'asc' }
    },
    filterButtonParams() {
      return this.showFilters ? { class: 'active', icon: 'angle-up' } : { class: '', icon: 'angle-down' }
    }
  },
  methods: {
    t(key, opts = {}) {
      return this.$t(`promtsAi.index.${key}`, opts)
    },
    confirmDelete(promt) {
      openModalConfirmRemove(
        this.t('confirmationModal.remove.title'),
        this.t('confirmationModal.remove.body', { name: promt.name }),
        this.t('confirmationModal.remove.okButton')
      ).then(() => this.destroy(promt.id))
    },
    getData(queryOptions) {
      this.$emit('load-data', queryOptions || this.lastQueryOptions)
      if (queryOptions) this.lastQueryOptions = queryOptions
    },
    destroy(id) {
      API.promtsAi.destroy(this.$route.params.id, id).then(() => {
        this.getData()
        this.$notifications.success(this.t('succesfullyDeleted'))
      })
    }
  }
})
